import { faClock } from '@fortawesome/pro-solid-svg-icons/faClock';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Grid, Typography } from '@mui/material';
import { GlobalClassKeys } from 'assets/jss/common-styles';
import MuiContainer from 'components/MuiExtras/MuiContainer';
import VideoPlayer from 'components/VideoPlayer';
import { Formaters } from 'lib/Formarters';
import { FileGetDto } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { getRenderVideoStyles, getVideoProps, RenderVideoWaitingEncode } from 'views/Publication/Components/RenderVideo/RenderVideoFile';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface RenderVideoState {
    playing: boolean;
}

interface RenderVideoProps {
    fileOrEmbedVideo: FileGetDto | string;
}

type Props = RenderVideoProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class QuizVideo extends React.Component<Props, RenderVideoState> {

    constructor(props: Props) {
        super(props);
        this.state = { playing: false };
    }

    ///
    public shouldComponentUpdate(nextProps: Props, nextState: RenderVideoState) {
        return nextProps.fileOrEmbedVideo != this.props.fileOrEmbedVideo || this.state.playing != nextState.playing;
    }

    ///
    public render() {
        const { fileOrEmbedVideo } = this.props;

        if (typeof fileOrEmbedVideo == "string") {
            return <div className={GlobalClassKeys.videoContainer} dangerouslySetInnerHTML={{ __html: fileOrEmbedVideo as string }}></div>;
        }

        const attach = fileOrEmbedVideo as FileGetDto;
        if (!attach.mimeType.startsWith("video/"))
            return null;

        const { playerId, sources, poster } = getVideoProps(attach);

        if (sources.length > 0) {
            const { innerStyles, outerStyles } = getRenderVideoStyles(attach);

            return (
                <div>
                    <MuiContainer>

                        <div style={outerStyles}>
                            <div className={GlobalClassKeys.videoContainer} style={innerStyles}>
                                <VideoPlayer
                                    className={GlobalClassKeys.videoPlayer}
                                    id={playerId}
                                    videoOptions={
                                        {
                                            autoplay: false,
                                            //aspectRatio: aspectRatio,
                                            controls: true,
                                            poster: poster,
                                            sources: sources,

                                            controlBar: {
                                                volumePanel: {
                                                    inline: false,
                                                    volumeControl: {
                                                        vertical: true
                                                    }
                                                },
                                            }
                                        }
                                    }
                                    onPlayStartError={
                                        () => this.setState({ playing: false })
                                    }
                                />
                            </div>
                        </div>

                        <Grid container direction="column" wrap="nowrap">
                            {
                                attach.metadata.title &&
                                <Grid item>
                                    <Typography variant="body2" component="p">
                                        {attach.metadata.title}
                                    </Typography>
                                </Grid>
                            }
                            {
                                attach.metadata.duration &&
                                <Grid item>
                                    <Typography variant="body2"><FontAwesomeIcon icon={faClock} />&nbsp;{Formaters.ticksToDurationString(attach.metadata.duration)}</Typography>
                                </Grid>
                            }
                        </Grid>
                    </MuiContainer>
                </div>
            );
        }

        return <RenderVideoWaitingEncode attach={attach} />;
    }
}

export default withTranslation()(QuizVideo);